import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import axiosInstance from '../../utils/axiosInstanse';
import host from "../../host";
import ToastNotification from '../Notification/ToastNotification';
import Spiner from "../Spiner/Spiner";
import PreviewButton from './PreviewButton';


const ReportModal = ({ isOpen, closeReportModal, showNotification, isMobile }) => {
    const [isModalOpen, setIsModalOpen] = useState(isOpen);
    const [loadingR, setLoadingR] = useState(false);
    const [dateFrom, setDateFrom] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [dateTo, setDateTo] = useState(() => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toISOString().split('T')[0];
    });

    const dispatch = useDispatch();
    const notification = useSelector(state => state.notification);

    const handleClick = async () => {
        setLoadingR(true);

        try {
            const response = await axiosInstance.get(`${host}api/get_guests_excel/`, {
                responseType: 'blob',
                params: {
                    date_from: dateFrom,
                    date_to: dateTo
                }
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `отчет_по_посетителям_за_${dateFrom}.xlsx`); // Имя файла
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            if (err.response && err.response.data) {
                const blob = err.response.data;
                const text = await blob.text();
                const errorData = JSON.parse(text);
                showNotification(dispatch, "Проверьте правильность введеных данных", "error");
            }

            setLoadingR(false);
        } finally {
            setLoadingR(false);
        }
    };

    return (
        isModalOpen && (
            <div className="pal-overlay" onClick={(e) => { if (e.target === e.currentTarget) closeReportModal(); }}>
                <div className="pal-modal">
                    <div className="pal-modal-header">
                        <h2 className="pal-modal-title">Получение отчета</h2>
                        <button className="pal-modal-close" onClick={closeReportModal}>✕</button>
                    </div>

                    <div className="pal-modal-body">
                        <div className="pal-grid-2">
                            <div className="pal-form-group">
                                <label>Выберите с какого числа</label>
                                <input className="pal-search-input" type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
                            </div>
                            <div className="pal-form-group">
                                <label>Выберите по какое число</label>
                                <input className="pal-search-input" type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
                            </div>
                        </div>

                        <div>
                            <div className='subtext'>Внимание: число "ПО" не включается в отчет!</div>
                        </div>

                        <div className={`d-flex gap-2 ${!isMobile ? "justify-content-between" : "flex-wrap justify-content-center"}`}>
                            <PreviewButton date_from={dateFrom} date_to={dateTo} />

                            <button
                                className="pal-filter-btn pal-filter-btn--green"
                                onClick={handleClick}
                                title="Получить отчет"
                                disabled={loadingR ? "disabled" : ""}
                            >
                                {!loadingR ? "Получить Excel файл" : "Подождите, пожалуйста.."}
                            </button>
                        </div>
                    </div>

                    <div className="pal-modal-footer">
                        <button className="pal-btn pal-btn--secondary" onClick={closeReportModal}>Отмена</button>
                        {/* <button className="pal-btn pal-btn--primary" onClick={handleSaveStatus}>Сохранить</button> */}
                    </div>
                </div>
            </div>
        )
    )
}

export default ReportModal;